import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Employeur } from "../core/model/employeur";
import { EmployeurService } from "../core/service/employeur.service";
import { EditEmployeurComponent } from "./edit-employeur/edit-employeur.component";
import { AddEmployeurComponent } from "./add-employeur/add-employeur.component";

@Component({
  selector: "app-employeur",
  templateUrl: "./employeur.component.html",
  styleUrls: ["./employeur.component.scss"],
})
export class EmployeurComponent implements OnInit {
  employeurs: Employeur[];
  employeur: Employeur;

  constructor(
    private _router: Router,
    private _employeurService: EmployeurService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getEmployeurs();
  }

  getEmployeurs() {
    this._employeurService.getAllEmployeurs().subscribe(
      (data) => {
        this.employeurs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  active(id) {
    this._employeurService.getEmployeurById(id).subscribe(
      (data) => {
        this.employeur = data;

        if (this.employeur.active == true) {
          this.employeur.active = false;
        } else {
          this.employeur.active = true;
        }

        this._employeurService
          .update(this.employeur)
          .pipe(first())
          .subscribe(
            (data1) => {
              this.getEmployeurs();
            },
            (error1) => {
              console.log(error1);
            }
          );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(employeurId): void {
    const modalRef = this.modalService.open(EditEmployeurComponent, {
      centered: true,
    });
    modalRef.componentInstance.employeurId = employeurId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getEmployeurs();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddEmployeurComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getEmployeurs();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
